module.exports = __webpack_public_path__ + "img/viber_with_beak.0487864d.svg";